import type { RuntimeLink } from '../../hooks/runtime/cmsApi'

const FALLBACK_HEADER_LINKS: { it: RuntimeLink[]; en: RuntimeLink[] } = {
  it: [
    { label: 'Catalogo', href: '#catalogo' },
    { label: 'Categorie', href: '#categorie' },
    { label: 'Offerte', href: '#offerte' },
    { label: 'Contatti', href: '#contatti' },
  ],
  en: [
    { label: 'Catalog', href: '#catalog' },
    { label: 'Categories', href: '#categories' },
    { label: 'Offers', href: '#offers' },
    { label: 'Contacts', href: '#contacts' },
  ],
}

export const resolveHeaderLinks = ({ links, language }: { links: RuntimeLink[]; language: 'it' | 'en' }) =>
  links.length ? links : language === 'en' ? FALLBACK_HEADER_LINKS.en : FALLBACK_HEADER_LINKS.it

export const resolveLinkLabel = (link: RuntimeLink, locale: string) => {
  const exact = link.labels?.[locale]
  if (exact && exact.trim()) return exact.trim()

  const languagePrefix = locale.split('-')[0]?.toLowerCase() || ''
  const byLanguage = Object.entries(link.labels ?? {}).find(([entryLocale, entryLabel]) => {
    if (typeof entryLabel !== 'string' || !entryLabel.trim()) return false
    const entryPrefix = entryLocale.split('-')[0]?.toLowerCase() || ''
    return entryPrefix === languagePrefix
  })
  if (byLanguage?.[1] && byLanguage[1].trim()) return byLanguage[1].trim()

  return link.label
}

export const resolveCustomerMenuLabels = (language: 'it' | 'en') =>
  language === 'en'
    ? {
        title: 'Customer area',
        account: 'Account',
        enter: 'Sign in',
        signedInAs: 'Signed in as',
        profile: 'Profile',
        orders: 'My orders',
        support: 'Support',
        logout: 'Log out',
        login: 'Customer login',
        signup: 'Create account',
      }
    : undefined
